import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {InjectedRouter} from 'react-router';
import {Link} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {AffinityLogo} from '../HomePage/AffinityLogo';
import {CampusSlider} from '../Components/CampusSlider';
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFooter} from '../Components/CampusFooter';
import {CampusFeedback} from './CampusFeedback';
import {WhyUs} from '../Components/WhyUs';
import { ResolveUrl } from '../tgccGlobal';
import { CampusCustomerContent } from '../Components/CampusCustomerContent';
import { LeadForm } from '../Components/LeadForm';

// URL-safe Base64 decoder function
const urlSafeBase64Decode = (str: string): string => {
    console.log('urlSafeBase64Decode input:', str);
    
    // First, handle URL encoding if present
    let decoded = decodeURIComponent(str);
    console.log('After URL decode:', decoded);
    
    // Replace URL-safe characters back to standard Base64
    decoded = decoded.replace(/-/g, '+').replace(/_/g, '/');
    console.log('After URL-safe conversion:', decoded);
    
    // Add padding if needed to make length a multiple of 4
    while (decoded.length % 4) {
        decoded += '=';
    }
    console.log('After padding:', decoded);
    
    try {
        // Decode using standard atob()
        const result = atob(decoded);
        console.log('Final decoded result:', result);
        console.log('Result length:', result.length);
        return result;
    } catch (error) {
        console.error('Error decoding Base64:', error);
        console.log('Failed to decode:', decoded);
        // If URL-safe Base64 fails, try regular Base64
        try {
            return atob(str);
        } catch (error2) {
            console.error('Regular Base64 also failed:', error2);
            throw error;
        }
    }
};

const homepageStyle: React.CSSProperties = {
    width: '100%',
};
const hdrStyle: React.CSSProperties = {
    height: '525px',
    display: 'flex',
    flexDirection: 'row',
};

const socialImg: React.CSSProperties = {
    width: '22px',
    height: '22px',
};
const brdImgDiv: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    minWidth: '100%',
    width: '100%',
    marginTop: '20px',
    gap: '10px',
};

const brandImgWrapper: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    padding: '10px',
    textAlign: 'center',
};

const brandDiv: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margin: '0 auto',
    maxWidth: 'none',
};

const brandHdr: React.CSSProperties = {
    fontSize: '40px',
    fontFamily: 'Lulo',
    color: '#3A54B4',
    marginTop: '50px',
};
const subbrandHdr: React.CSSProperties = {
    color: '#040A5E',
    fontSize: '18px',
};
const brandImg: React.CSSProperties = {
    maxWidth: '100%',
    height: 'auto',
    cursor: 'pointer',
};

const prodStyle: React.CSSProperties = {
    textAlign: 'center',
    fontFamily: 'BarlowLight',
    fontSize: '20px',
    color: '#050A5E',
};
const steps: React.CSSProperties = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
};

const startProof: React.CSSProperties = {
    marginTop: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Lulo',
    backgroundColor: '#233D92',
    color: 'white',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '25px',
    width: '300px',
    textAlign: 'center',
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    left: '50%',
    '@media (max-width: 801px)': {
        top: '81%',
        transform: 'translate(-50%, -50%)',
    },
    '@media (min-width: 802px)': {
        top: '82%',
        transform: 'translateX(-50%)',
    },
};

const imageStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    paddingBottom: '30px',
};

const designCont: React.CSSProperties = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
        display: 'none',
    },
};

const designBtn: React.CSSProperties = {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    top: '78%',
    left: '50%',
    backgroundColor: '#9F9F9F',
    color: 'black',
    fontFamily: 'Lulo',
    width: '250px',
    padding: '10px',
    borderRadius: '25px',
    textAlign: 'center',
    cursor: 'pointer',
    '@media (max-width: 800px)': {
        top: 'auto',
        bottom: '3vh',
        transform: 'translate(-50%, 0%)',
        width: '200px',
        padding: '8px',
        fontSize: '14px',
        borderRadius: '20px',
    },
    '@media (max-width: 600px)': {
        display: 'none',
    },
};

const serviceCont: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl('~/images/campus-banner-03.png') + ')',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '50vh',
    display: 'flex',
    marginTop: '50px',
    marginBottom: '20px',
};

const campusMobProofImg: React.CSSProperties = {
    display: 'none',
};
const questionLink: React.CSSProperties = {
    marginTop: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Lulo',
    backgroundColor: '#233D92',
    color: 'white',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '25px',
    width: '300px',
    textAlign: 'center',
    cursor: 'pointer',
    position: 'relative',
    top: '-25px',
};
const heroRegisterButtonStyle: React.CSSProperties = {
    position: 'absolute',
    top: '44%',
    left: '84%',
    transform: 'translate(-50%, -50%)',
    width: '24%',
    height: '17%',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
};

const campusHomeDesStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    '@media (max-width: 600px)': {
        display: 'none',
    },
};

const popupOverlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
};

const popupStyle: React.CSSProperties = {
    width: '400px',
    background: '#fff',
    borderRadius: '10px',
    padding: '20px',
    textAlign: 'center',
    position: 'relative',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    animation: 'fadeIn 0.5s',
};

const popupHeaderStyle: React.CSSProperties = {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#3A54B4',
    marginBottom: '15px',
};

const popupMessageStyle: React.CSSProperties = {
    fontSize: '16px',
    color: '#555',
    marginBottom: '20px',
};

const popupNoteStyle: React.CSSProperties = {
    fontSize: '12px',
    color: '#777',
    marginTop: '10px',
};

const popupButtonStyle: React.CSSProperties = {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#3A54B4',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
};

const popupCloseStyle: React.CSSProperties = {
    position: 'absolute',
    top: '10px',
    right: '15px',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#aaa',
};

class Props extends Tgcc.BaseProps {
    ActiveProof: Tgcc.Proof;
}

class _Campus extends React.Component<Props, any> {
    state = {
        homepage: "",
        help: false,
        showPopup: false,
    };

    componentWillMount() {
        if (this.props.location.query.u && this.props.location.query.c) {
            console.log('Raw URL parameters:', {
                u: this.props.location.query.u,
                c: this.props.location.query.c
            });
            
            var decodedEmail = urlSafeBase64Decode(this.props.location.query.u);
            
            // Convert spaces back to + characters in the token (URL encoding issue)
            var rawToken = this.props.location.query.c.replace(/ /g, '+');
            console.log('Raw token being sent to backend:', rawToken);
            
            console.log('Values being sent:', {
                email: decodedEmail,
                token: rawToken,
                tokenLength: rawToken.length
            });
            
            this.props.dispatch({
                type: Tgcc.StateAction.DialogAction,
                payload: {
                    action: Tgcc.DialogAction.ResetPassword,
                    payload: { token: rawToken, email: decodedEmail },
                },
            });
        }
    }

    componentDidMount() {
        var tag = document.getElementById('homepage');
        tag.scrollIntoView(false);

        setTimeout(() => {
            this.setState({ showPopup: true });
        }, 7000);
    }

    closePopup = () => {
        this.setState({ showPopup: false });
    };

    openRegister = () => {
        browserHistory.push(Tgcc.Routes.CampusRegister);
    };

    openDesigns = () => {
        browserHistory.push(Tgcc.Routes.CampusDesignListView);
    };

    openContact = () => {
        browserHistory.push(Tgcc.Routes.CampusContact);
    };

    openComfort = () => {
        browserHistory.push(Tgcc.Routes.CampusProductView('Comfort Colors', '6030', 'Violet'));
    };

    openAlt = () => {
        browserHistory.push(Tgcc.Routes.CampusProductView('Alternative Apparel', '1070', 'Bright Red'));
    };

    openChamp = () => {
        browserHistory.push(Tgcc.Routes.CampusProductView('Champion', 'S600', 'Black'));
    };

    openProducts = () => {
        browserHistory.push(Tgcc.Routes.CampusProductListView);
    };

    renderPopup = () => {
        const now = new Date();
        const endDate = new Date('2025-04-30T23:59:59'); // End of April 30th
    
        if (!this.state.showPopup || now > endDate) return null;
    
        return (
            <div style={popupOverlayStyle}>
                <div style={popupStyle}>
                    <div style={popupHeaderStyle}>🚚 Free Shipping Alert!</div>
                    <div style={popupMessageStyle}>
                        Enjoy free ground shipping on all <strong>campus</strong> orders until <strong>April 30th</strong>! Don't miss out – shop now.
                    </div>
                    <button style={popupButtonStyle} onClick={this.closePopup}>
                        Shop Now
                    </button>
                    <div style={popupNoteStyle}>*Does not apply to custom art orders</div>
                    <span style={popupCloseStyle} onClick={this.closePopup}>
                        &times;
                    </span>
                </div>
            </div>
        );
    };
    

    render() {
        return (
            <div style={homepageStyle}>
                <div id="homepage"></div>
                {this.renderPopup()}
                <CampusHeader />
                <CampusFeedback state={this.props.state} />
                <div style={steps} className="campusSteps">
                    <img 
                        src={Tgcc.ResolveUrl('~/images/CampusWebBanner2025.jpg')} 
                        alt="Step Banner" 
                        style={imageStyle} 
                        className='campusStepsImg'
                    />
                    <a id="hero-register-button" style={heroRegisterButtonStyle} onClick={this.openRegister}></a>
                </div>
                <div style={designCont} className="campusHomDes" onClick={this.openDesigns}>
                    <img 
                        src={Tgcc.ResolveUrl('~/images/campus-banner-02.png')} 
                        alt="Campus Banner" 
                        className='campusHomeDesImg'
                        style={campusHomeDesStyle}
                    />
                    <div style={designBtn} className="campusViewDesigns" onClick={this.openDesigns}>View Designs</div>
                </div>
                <div style={serviceCont} className="campusService" onClick={this.openContact}>
                    <a style={questionLink} className="campusContact" key={1} href="mailto:sales@grafcow.com">Contact Us</a>
                </div>
                <div style={brandDiv}>
                    <div style={brandHdr} className="brandWe">BRANDS WE LOVE</div>
                    <div style={subbrandHdr}>& we know you will too!</div>
                    <div style={brdImgDiv} className="brandPrd">
                        <div style={brandImgWrapper}>
                            <div style={prodStyle}>Comfort Colors - 6030</div>
                            <img key={3} className="prodImg" onClick={this.openComfort} style={brandImg} src={Tgcc.ResolveUrl('~/images/ComfortColors6030.jpeg')} />
                        </div>
                        <div style={brandImgWrapper}>
                            <div style={prodStyle}> Alternative - 1070</div>
                            <img key={4} className="prodImg" onClick={this.openAlt} style={brandImg} src={Tgcc.ResolveUrl('~/images/AA1070.jpeg')} />
                        </div>
                        <div style={brandImgWrapper}>
                            <div style={prodStyle}>Champion S600</div>
                            <img key={5} className="prodImg" onClick={this.openChamp} style={brandImg} src={Tgcc.ResolveUrl('~/images/ChampionS600.jpeg')} />
                        </div>
                    </div>
                    <div onClick={this.openProducts}>VIEW ALL PRODUCTS</div>
                </div>
                <CampusCustomerContent />
                <CampusFooter state={this.props.state} />
            </div>
        );
    }
}

var radiumCampusPage = Radium(_Campus);

const mapStateToProps = (state: Tgcc.GlobalState) => { 
    return { ActiveProof: state.ActiveProof, state: state };
};
export var Campus = connect(mapStateToProps)(radiumCampusPage);
